import {
  SET_SEARCH_FILTER,
  SEARCH_ORDER,
  SET_ORDER_MODAL,
  SET_MODAL_VALUES,
  SET_MODAL_ERRORS,
  SET_MODAL_STATES,
  SET_ORDER,
  ORDER_ERROR,
  UPDATE_CONTACT_INFO,
  UPDATE_SHIPPING_ADD,
  CREATE_ORDER_FULFILLMENT,
  EDIT_ORDER_FULFILLMENT,
  CALCULATE_ORDER_REFUND,
  CREATE_ORDER_REFUND,
  CLEAR_REFUND,
  SET_LOADING,
  GET_TRANSACTIONS,
} from "../../types";

const OrdersReducer = (state, action) => {
  switch (action.type) {
    case SET_SEARCH_FILTER:
      return { ...state, searchFilter: action.payload };

    case SEARCH_ORDER:
      return { ...state, searchResult: action.payload };

    case SET_ORDER_MODAL:
      return {
        ...state,
        modalOpen: action.payload[0],
        modalFunction: action.payload[1],
      };

    case SET_MODAL_VALUES:
      return { ...state, modalValues: action.payload };

    case SET_MODAL_ERRORS:
      return { ...state, modalErrors: action.payload };

    case SET_MODAL_STATES:
      return { ...state, modalStates: action.payload };

    case SET_ORDER:
    case UPDATE_CONTACT_INFO:
    case UPDATE_SHIPPING_ADD:
    case CREATE_ORDER_FULFILLMENT:
    case EDIT_ORDER_FULFILLMENT:
    case CREATE_ORDER_REFUND:
      return { ...state, order: action.payload };

    case CALCULATE_ORDER_REFUND:
    case CLEAR_REFUND:
      return {
        ...state,
        refund: action.payload[0],
        refund_error: action.payload[1],
        loading: false,
      };

    case SET_LOADING:
      return { ...state, loading: true };

    case GET_TRANSACTIONS:
      return { ...state, transactions: action.payload };

    case ORDER_ERROR:
      return { ...state, order_error: action.payload };

    default:
      return state;
  }
};

export default OrdersReducer;